import React from "react";

// Assets
import error from "Assets/Icons/warning-2.svg";
import check from "Assets/Icons/tick-circle.svg";
import withdraw from "Assets/Icons/money-time.svg";
import infoCircle from "Assets/Icons/info-circle.svg";
import "./Icon.scss";

const IconTypeNames = {
  error: "error",
  check: "check",
  withdraw: "withdraw",
  enrollsuccess: "enrollsuccess",
  enrollfail: "enrollfail",
};

const Icon = ({ typeName }) => {
  let icon;

  switch (typeName?.toLowerCase()) {
    case IconTypeNames.error:
      icon = (
        <img
          className="icon"
          alt="exclamation point"
          src={error}
          width={70}
          height={70}
        />
      );
      break;
    case IconTypeNames.check:
      icon = <img alt="encircled check mark" src={check} />;
      break;
    case IconTypeNames.withdraw:
      icon = (
        <img alt="hourglass bottom" src={withdraw} width={120} height={120} />
      );
      break;
    case IconTypeNames.enrollsuccess:
      icon = (
        <img alt="encircled check mark" src={check} width={70} height={70} />
      );
      break;
    case IconTypeNames.enrollfail:
      icon = <img className="icon" alt="exclamation point" src={error} />;
      break;
    case IconTypeNames.deviceVerificationError:
      icon = <img className="icon" alt="info circle" src={infoCircle} />;
      break;
    default:
      icon = <img alt="icon missing" src="" />;
  }
  return <>{icon && icon}</>;
};

export { IconTypeNames };
export default Icon;
